/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, toString, isEmpty } from "lodash";
import {
  IconButton,
  Pagination,
  Stack,
  Chip,
  Menu,
  MenuItem,
  Link as LinkMui,
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Link } from "react-router-dom";
import { countPage } from "../../../config/const";
import { useCanView } from "../../../config/hook/UserPermissions";

import Layout from "../../../components/layout/Layout";
import Table from "../../../components/form/TableFilter";
import Toolbar from "./Toolbar";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Question from "../../../components/form/Question";

import { getBillingCode } from "../../../store/masters/thunk/billingCode/getAll";
import { deleteBillingCode } from "../../../store/masters/thunk/billingCode/delete";
import { getBillingCodeOdoo } from "../../../store/masters/thunk/billingCode/getOdooProducts";

const BillingCode = () => {
  const [__] = useTranslation("billingCode");
  const dispatch = useDispatch();
  const canView = useCanView();
  const [filter, setFilter] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({});
  const [openQuestion, setOpenQuestion] = useState(false);
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" });
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });

  const billingCode = useSelector(state => state.masters.billingCode);
  const delet = useSelector(state => state.masters.billingCode.delete);

  const getData = ({ page, filters = filter }) => {
    dispatch(getBillingCode({ page, ...filters }));
    dispatch(getBillingCodeOdoo());
  }

  const reload = () => {
    handleCloseMenu();
    closeAlert();
    getData({ page: 1 });
  }

  useEffect(() => {
    setAnchorEl(false);
    getData({ page: 1 });
  }, []);

  const onFilterChange = (key, value) => {
    const updatedFilters = { ...filter, [key]: value };
    setFilter(updatedFilters);
    getData({ page: 1, filters: updatedFilters });
  };

  const handleOpenMenu = (row) => (event) => {
    setSelected(row);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setSelected({});
    setAnchorEl(null);
  };

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" });
    setOpenQuestion(false);
  }

  const setError = (err) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        func: closeAlert
      });
    } else {
      setAlert({ open: true, type: "default", func: closeAlert });
    }
    handleCloseMenu();
  }

  useEffect(() => {
    if (get(delet, "isSuccess", false)) {
      reload();
      setShowNoti({ open: true, msg: "", variant: "success", action: "delet" });
    }
    if (get(delet, "isReject", false)) {
      setError(get(delet, "error", {}));
    }
  }, [delet]);

  const onDelete = () => {
    dispatch(deleteBillingCode({ billingCodeId: get(selected, "coD_FACTURA") }));
    setSelected({});
  }

  const handleDelete = (row) => () => {
    setAnchorEl(null);
    setOpenQuestion(true);
    setSelected(row);
  }

  const headTable = [
    { key: "status", label: __(`table.cols.isActive`), align: "center" },
    { key: "coD_FACTURA", label: __(`table.cols.codFactura`), align: "center" },
    { key: "description", label: __(`table.cols.description`), align: "left" },
    { key: "odooProductInternal", label: __(`table.cols.odooProductInternal`), align: "center" },
    { key: "odooProductName", label: __(`table.cols.odooProductName`), align: "left" },
    {
      key: "options",
      label: __(`table.cols.options`),
      align: "center",
      sx: {
        position: "sticky",
        right: 0,
        pr: 1,
        width: 40,
        minWidth: 40,
        background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)",
      }
    },
  ]

  const dataTable = map(get(billingCode, "data.data", []), (row) => ({
    ...row,
    status: <Chip label={__(`isActive.${get(row, "isActive", false)}`)} color={get(row, "isActive", false) ? "success" : "error"} />,
    coD_FACTURA: (
      <LinkMui component={Link} to={toString(get(row, "coD_FACTURA"))}>
        {get(row, "coD_FACTURA")}
      </LinkMui>
    ),
    options: (
      <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}>
        <MoreVertIcon fontSize="inherit" />
      </IconButton>
    ),
  }))

  const onChangePagination = (e, page) => getData({ page, filter });

  return (
    <Layout propsToolbar={{ title: __(`head.name`), code: null, btnLabel: null }}>
      <Toolbar setFilter={setFilter} __={__} getData={getData} reload={reload} isLoading={get(billingCode, "isLoading", false)} />
      <Table
        headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        propsTable={{ showFilterRow: true }}
        filters={filter}
        onFilterChange={onFilterChange}
        loading={get(billingCode, "isLoading", false)}
      />
      {get(billingCode, "isSuccess", true) && (
        <Stack sx={{ mt: 2 }} alignItems="flex-end">
          <Pagination
            count={countPage(get(billingCode, "data.totalRecord", 1))}
            page={get(billingCode, "data.currentPage", 1)}
            onChange={onChangePagination}
            color="secondary"
            sx={{ "& li > button": { borderRadius: 1 } }}
            disabled={get(billingCode, "isLoading", false)}
          />
        </Stack>
      )}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        <Link to={toString(get(selected, "coD_FACTURA"))}>
          <MenuItem>{__(`table.menu.edit`)}</MenuItem>
        </Link>
        <MenuItem
          onClick={() => {
            if (canView("CONFIGURACIÓN/CODIGOS FACTURACION", "delete")) {
              handleDelete(selected)();
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: <ul> • No tienes permiso para eliminar códigos de facturación.</ul>,
                type: "error",
                func: closeAlert,
              });
            }
          }}
        >
          {__(`table.menu.delete`)}
        </MenuItem>
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <Question
        title={__("alert.delete.title")}
        detail={__("alert.delete.detail")}
        onSuccess={onDelete}
        onCancel={() => setOpenQuestion(false)}
        open={openQuestion}
        loading={get(delet, "isLoading")}
      />
    </Layout>
  )
}

export default BillingCode;
